interface LogoProps {
  image: string
  alt: string
  url?: string | null | undefined
  className?: string
}

export function Logo({ image, alt, url, className }: LogoProps) {
  const imgClasses = className
    ? `${className} w-auto object-contain`
    : 'max-h-24 w-auto object-contain'

  const imgElement = <img src={image} alt={alt} className={imgClasses} />

  if (url) {
    return (
      <a
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        className='hover:opacity-80 transition-opacity duration-200'
      >
        {imgElement}
      </a>
    )
  }

  return <div>{imgElement}</div>
}
